export interface DramaEpisode {
  num: number;
  title: string;
  duration: string;
}

export interface Drama {
  id: string;
  title: string;
  category: string;
  subCategory: string;
  year: number;
  rating: number;
  coverImage: string;
  posterImage: string;
  description: string;
  director: string;
  cast: string[];
  region: string;
  language: string;
  totalEpisodes: number;
  currentEpisode: number;
  status: '连载中' | '已完结';
  tags: string[];
  isFeatured: boolean;
  isHot: boolean;
  isNew: boolean;
  updateTime: string;
  episodes: DramaEpisode[];
}

export const categories = [
  { key: 'guochan', name: '国产剧', icon: 'ri-flag-2-line' },
  { key: 'hanju', name: '韩剧', icon: 'ri-heart-line' },
  { key: 'meiju', name: '美剧', icon: 'ri-global-line' },
  { key: 'riju', name: '日剧', icon: 'ri-sun-line' },
  { key: 'dongman', name: '动漫', icon: 'ri-movie-2-line' },
  { key: 'zongyi', name: '综艺', icon: 'ri-tv-line' },
];

export const dramas: Drama[] = [
  {
    id: 'drama-1',
    title: '长安十二时辰',
    category: 'guochan',
    subCategory: '古装悬疑',
    year: 2019,
    rating: 8.3,
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20detective%20drama%20poster%20with%20Tang%20Dynasty%20warrior%20in%20dark%20armor%20standing%20in%20ancient%20city%20street%20at%20night%2C%20lanterns%20glowing%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20period%20costume%20drama%20poster%20style&width=600&height=800&seq=chang-an-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Tang%20Dynasty%20ancient%20Chinese%20city%20panorama%20at%20night%20with%20lanterns%2C%20watchtowers%2C%20and%20mysterious%20silhouettes%2C%20cinematic%20widescreen%20composition%2C%20dark%20dramatic%20atmosphere%2C%20film%20noir%20style&width=1200&height=500&seq=chang-an-poster&orientation=landscape',
    description: '唐朝天宝三年，上元节前夕，长安城陷入危机。死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内拯救长安。一场关于忠诚、勇气与智慧的较量在千年古都展开，各方势力暗流涌动，真相扑朔迷离。',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '芦芳生'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 48,
    currentEpisode: 48,
    status: '已完结',
    tags: ['悬疑', '古装', '历史', '剧情'],
    isFeatured: true,
    isHot: true,
    isNew: false,
    updateTime: '2024-06-15',
    episodes: Array.from({ length: 48 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '45分钟',
    })),
  },
  {
    id: 'drama-2',
    title: '狂飙',
    category: 'guochan',
    subCategory: '刑侦涉案',
    year: 2023,
    rating: 8.5,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20police%20officer%20and%20gangster%20facing%20each%20other%20in%20dark%20alley%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20tense%20atmosphere%2C%20film%20noir%20aesthetic%2C%20dramatic%20shadows&width=600&height=800&seq=kuangbiao-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20city%20nightscape%20with%20police%20cars%20and%20neon%20lights%2C%20rain%20soaked%20streets%2C%20crime%20drama%20atmosphere%2C%20cinematic%20widescreen%2C%20dark%20moody%20tone&width=1200&height=500&seq=kuangbiao-poster&orientation=landscape',
    description: '以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开了长达二十年的生死较量。从一名普通鱼贩到称霸一方的黑社会头目，高启强的堕落之路令人唏嘘。展现了扫黑除恶工作的艰辛与政法队伍的坚定决心。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 39,
    currentEpisode: 39,
    status: '已完结',
    tags: ['刑侦', '涉案', '剧情', '扫黑'],
    isFeatured: true,
    isHot: true,
    isNew: false,
    updateTime: '2024-05-20',
    episodes: Array.from({ length: 39 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '45分钟',
    })),
  },
  {
    id: 'drama-3',
    title: '庆余年第二季',
    category: 'guochan',
    subCategory: '古装玄幻',
    year: 2024,
    rating: 7.9,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20poster%20with%20handsome%20scholar%20in%20flowing%20robe%20holding%20sword%2C%20ancient%20palace%20background%2C%20dramatic%20lighting%2C%20epic%20costume%20drama%20style%2C%20mystical%20elements&width=600&height=800&seq=qingyunian2-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20grand%20hall%20with%20dramatic%20lighting%2C%20epic%20fantasy%20atmosphere%2C%20golden%20and%20crimson%20color%20scheme%2C%20cinematic%20widescreen%20composition&width=1200&height=500&seq=qingyunian2-poster&orientation=landscape',
    description: '范闲在经历生死考验后，重返京都。朝堂之上风云变幻，各方势力明争暗斗。他周旋于庆帝、陈萍萍等权臣之间，一步步揭开母亲叶轻眉之死的真相。第二季将带来更加激烈的权谋较量和更宏大的世界观。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 36,
    currentEpisode: 24,
    status: '连载中',
    tags: ['古装', '玄幻', '权谋', '剧情'],
    isFeatured: true,
    isHot: true,
    isNew: true,
    updateTime: '2026-08-01',
    episodes: Array.from({ length: 36 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '45分钟',
    })),
  },
  {
    id: 'drama-4',
    title: '三体',
    category: 'guochan',
    subCategory: '科幻',
    year: 2023,
    rating: 8.7,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20with%20three%20suns%20in%20alien%20sky%2C%20mysterious%20cosmic%20phenomenon%2C%20dark%20universe%20background%2C%20futuristic%20aesthetic%2C%20hard%20science%20fiction%20style&width=600&height=800&seq=santi-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Deep%20space%20with%20three%20stars%20system%2C%20cosmic%20radiation%2C%20alien%20planet%20surface%2C%20mysterious%20universe%2C%20sci-fi%20cinematic%20landscape%2C%20dark%20epic%20atmosphere&width=1200&height=500&seq=santi-poster&orientation=landscape',
    description: '纳米科学家汪淼被警官史强带入一个神秘组织"科学边界"，揭开地球基础科学受到未知力量干扰的真相。一场人类文明与三体文明的星际博弈就此展开。改编自刘慈欣同名科幻巨著，是国产科幻剧的里程碑之作。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 30,
    currentEpisode: 30,
    status: '已完结',
    tags: ['科幻', '悬疑', '剧情', '史诗'],
    isFeatured: false,
    isHot: true,
    isNew: false,
    updateTime: '2024-04-10',
    episodes: Array.from({ length: 30 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '50分钟',
    })),
  },
  {
    id: 'drama-5',
    title: '黑暗荣耀',
    category: 'hanju',
    subCategory: '复仇悬疑',
    year: 2023,
    rating: 8.9,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20drama%20poster%20with%20elegant%20woman%20in%20black%20dress%20standing%20in%20front%20of%20chess%20board%2C%20dark%20minimalist%20background%2C%20cold%20expression%2C%20dramatic%20lighting%2C%20premium%20K-drama%20style&width=600&height=800&seq=dark-glory-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Dark%20minimalist%20room%20with%20chess%20pieces%20and%20shadows%2C%20Korean%20drama%20aesthetic%2C%20cold%20winter%20atmosphere%2C%20elegant%20but%20menacing%2C%20cinematic%20composition&width=1200&height=500&seq=dark-glory-poster&orientation=landscape',
    description: '文东恩在高中时期遭受校园暴力后，精心策划了一场长达十余年的复仇计划。她成为施暴者女儿的班主任，一步步瓦解那些曾经伤害她的人的生活。一部关于复仇、救赎与人性的黑暗童话。',
    director: '安吉镐',
    cast: ['宋慧乔', '李到晛', '林智妍', '郑成日'],
    region: '韩国',
    language: '韩语',
    totalEpisodes: 16,
    currentEpisode: 16,
    status: '已完结',
    tags: ['复仇', '悬疑', '校园暴力', '剧情'],
    isFeatured: true,
    isHot: true,
    isNew: false,
    updateTime: '2024-03-15',
    episodes: Array.from({ length: 16 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '50分钟',
    })),
  },
  {
    id: 'drama-6',
    title: '眼泪女王',
    category: 'hanju',
    subCategory: '浪漫爱情',
    year: 2024,
    rating: 8.2,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20drama%20poster%20with%20elegant%20couple%20in%20luxury%20setting%2C%20woman%20in%20designer%20dress%2C%20man%20in%20suit%2C%20sparkling%20atmosphere%2C%20soft%20romantic%20lighting%2C%20K-drama%20poster%20style&width=600&height=800&seq=tears-queen-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Luxury%20penthouse%20with%20city%20skyline%20view%20at%20sunset%2C%20elegant%20interior%20design%2C%20romantic%20atmosphere%2C%20Korean%20drama%20aesthetic%2C%20warm%20golden%20light&width=1200&height=500&seq=tears-queen-poster&orientation=landscape',
    description: '皇后集团财阀三代洪海仁与龙头里超市王子白贤宇结婚三年后，婚姻陷入危机。正当两人决定离婚之际，海仁被诊断出罹患绝症。面对生死考验，这对夫妻重新审视彼此的感情，展开了一段笑泪交织的浪漫故事。',
    director: '张英宇',
    cast: ['金秀贤', '金智媛', '朴成焄', '郭东延'],
    region: '韩国',
    language: '韩语',
    totalEpisodes: 16,
    currentEpisode: 16,
    status: '已完结',
    tags: ['爱情', '喜剧', '财阀', '剧情'],
    isFeatured: false,
    isHot: true,
    isNew: true,
    updateTime: '2026-07-28',
    episodes: Array.from({ length: 16 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '70分钟',
    })),
  },
  {
    id: 'drama-7',
    title: '背着善宰跑',
    category: 'hanju',
    subCategory: '奇幻爱情',
    year: 2024,
    rating: 8.6,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20youth%20romance%20drama%20poster%20with%20young%20couple%20running%20through%20cherry%20blossom%20path%2C%20soft%20pastel%20colors%2C%20spring%20atmosphere%2C%20K-drama%20romantic%20comedy%20style&width=600&height=800&seq=lovely-runner-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Cherry%20blossom%20tree-lined%20street%20in%20spring%2C%20Korean%20university%20campus%20aesthetic%2C%20warm%20sunlight%2C%20romantic%20youthful%20atmosphere%2C%20soft%20cinematic%20look&width=1200&height=500&seq=lovely-runner-poster&orientation=landscape',
    description: '因意外事故导致下半身瘫痪的任率，偶然发现自己可以通过手表穿越回到过去。她决定回到高中时期，改变自己和偶像柳善宰的命运。一场跨越时空的青春罗曼史就此展开，每一次穿越都牵动着两个人的命运。',
    director: '尹钟镐',
    cast: ['金惠允', '边佑锡', '宋建熙', '李承协'],
    region: '韩国',
    language: '韩语',
    totalEpisodes: 16,
    currentEpisode: 16,
    status: '已完结',
    tags: ['奇幻', '爱情', '穿越', '青春'],
    isFeatured: false,
    isHot: false,
    isNew: true,
    updateTime: '2026-07-25',
    episodes: Array.from({ length: 16 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '60分钟',
    })),
  },
  {
    id: 'drama-8',
    title: '请回答1988',
    category: 'hanju',
    subCategory: '青春怀旧',
    year: 2015,
    rating: 9.7,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20retro%20family%20drama%20poster%20with%20five%20teenagers%20sitting%20together%20in%201980s%20style%20clothing%2C%20warm%20nostalgic%20atmosphere%2C%20vintage%20color%20tone%2C%20heartwarming%20K-drama%20style&width=600&height=800&seq=reply1988-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Narrow%20Korean%20neighborhood%20alley%20in%201980s%2C%20traditional%20houses%2C%20warm%20nostalgic%20atmosphere%2C%20vintage%20film%20aesthetic%2C%20golden%20afternoon%20light%2C%20heartwarming%20community&width=1200&height=500&seq=reply1988-poster&orientation=landscape',
    description: '故事以1988年汉城奥运会为背景，讲述了首尔双门洞五家人的故事。五个从小一起长大的小伙伴——德善、正焕、善宇、东龙和崔泽，在18岁的青春年华里，共同经历了友情、亲情和懵懂爱情的温暖时光。',
    director: '申元浩',
    cast: ['李惠利', '朴宝剑', '柳俊烈', '高庚杓'],
    region: '韩国',
    language: '韩语',
    totalEpisodes: 20,
    currentEpisode: 20,
    status: '已完结',
    tags: ['青春', '家庭', '怀旧', '温情'],
    isFeatured: false,
    isHot: false,
    isNew: false,
    updateTime: '2024-01-01',
    episodes: Array.from({ length: 20 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '90分钟',
    })),
  },
  {
    id: 'drama-9',
    title: '权力的游戏',
    category: 'meiju',
    subCategory: '奇幻史诗',
    year: 2011,
    rating: 9.4,
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20drama%20poster%20with%20iron%20throne%20made%20of%20swords%2C%20dark%20medieval%20atmosphere%2C%20dragon%20silhouette%20in%20background%2C%20HBO%20style%20promotional%20art%2C%20dramatic%20lighting&width=600&height=800&seq=got-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Medieval%20fantasy%20kingdom%20with%20dragons%20flying%20over%20snowy%20mountains%2C%20epic%20castle%20on%20cliff%2C%20dark%20dramatic%20sky%2C%20cinematic%20widescreen%2C%20HBO%20production%20quality&width=1200&height=500&seq=got-poster&orientation=landscape',
    description: '在维斯特洛大陆上，几大家族为争夺铁王座展开了残酷的权力斗争。史塔克家族、兰尼斯特家族、坦格利安家族——各方势力明争暗斗，冰与火之歌响彻大陆。夜王率领异鬼大军从绝境长城以北南下，人类面临前所未有的威胁。',
    director: '戴维·贝尼奥夫',
    cast: ['艾米莉亚·克拉克', '基特·哈灵顿', '彼特·丁拉基', '琳娜·海蒂'],
    region: '美国',
    language: '英语',
    totalEpisodes: 73,
    currentEpisode: 73,
    status: '已完结',
    tags: ['奇幻', '史诗', '战争', '剧情'],
    isFeatured: true,
    isHot: true,
    isNew: false,
    updateTime: '2024-02-20',
    episodes: Array.from({ length: 73 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '55分钟',
    })),
  },
  {
    id: 'drama-10',
    title: '绝命毒师',
    category: 'meiju',
    subCategory: '犯罪剧情',
    year: 2008,
    rating: 9.6,
    coverImage: 'https://readdy.ai/api/search-image?query=American%20crime%20drama%20poster%20with%20middle-aged%20man%20in%20yellow%20hazmat%20suit%20standing%20in%20desert%2C%20minimalist%20design%2C%20dark%20humor%20aesthetic%2C%20AMC%20style&width=600&height=800&seq=breaking-bad-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=New%20Mexico%20desert%20landscape%20with%20RV%20camper%20in%20distance%2C%20golden%20hour%20light%2C%20vast%20open%20sky%2C%20lonely%20highway%2C%20cinematic%20American%20Southwest%20aesthetic&width=1200&height=500&seq=breaking-bad-poster&orientation=landscape',
    description: '高中化学老师沃尔特·怀特被诊断出晚期肺癌后，为了在离世前给家人留下足够的钱财，利用自己的化学知识开始制造冰毒。从一个唯唯诺诺的平凡教师，到令人闻风丧胆的毒枭海森堡，他的转变令人震撼。',
    director: '文斯·吉里根',
    cast: ['布莱恩·科兰斯顿', '亚伦·保尔', '安娜·冈', '迪恩·诺里斯'],
    region: '美国',
    language: '英语',
    totalEpisodes: 62,
    currentEpisode: 62,
    status: '已完结',
    tags: ['犯罪', '剧情', '惊悚', '黑色'],
    isFeatured: false,
    isHot: false,
    isNew: false,
    updateTime: '2024-01-15',
    episodes: Array.from({ length: 62 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '47分钟',
    })),
  },
  {
    id: 'drama-11',
    title: '怪奇物语',
    category: 'meiju',
    subCategory: '科幻惊悚',
    year: 2016,
    rating: 9.1,
    coverImage: 'https://readdy.ai/api/search-image?query=Netflix%20sci-fi%20horror%20series%20poster%20with%20four%20kids%20on%20bicycles%20at%20night%2C%201980s%20retro%20style%2C%20neon%20red%20title%2C%20mysterious%20glow%2C%20nostalgic%20adventure%20vibe&width=600&height=800&seq=stranger-things-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Small%20American%20town%20at%20night%20with%20flickering%20street%20lights%2C%201980s%20aesthetic%2C%20misty%20atmosphere%2C%20mysterious%20upside-down%20world%20vibe%2C%20cinematic%20horror&width=1200&height=500&seq=stranger-things-poster&orientation=landscape',
    description: '1983年印第安纳州霍金斯小镇，一名小男孩神秘失踪。他的朋友们、家人和当地警察开始寻找真相，却卷入了一个涉及秘密政府实验、超自然力量和另一个维度的谜团中。拥趸们亲切地称小11为"十一"。',
    director: '达菲兄弟',
    cast: ['米莉·波比·布朗', '芬恩·伍法德', '薇诺娜·瑞德', '大卫·哈伯'],
    region: '美国',
    language: '英语',
    totalEpisodes: 34,
    currentEpisode: 34,
    status: '连载中',
    tags: ['科幻', '惊悚', '怀旧', '冒险'],
    isFeatured: false,
    isHot: false,
    isNew: false,
    updateTime: '2024-06-01',
    episodes: Array.from({ length: 34 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '50分钟',
    })),
  },
  {
    id: 'drama-12',
    title: '风骚律师',
    category: 'meiju',
    subCategory: '犯罪剧情',
    year: 2015,
    rating: 9.3,
    coverImage: 'https://readdy.ai/api/search-image?query=American%20legal%20drama%20poster%20with%20lawyer%20in%20colorful%20suit%20holding%20briefcase%2C%20desert%20highway%20background%2C%20quirky%20character%2C%20AMC%20style%2C%20warm%20Southwest%20tones&width=600&height=800&seq=better-call-saul-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Albuquerque%20strip%20mall%20with%20law%20office%20neon%20sign%2C%20American%20Southwest%20architecture%2C%20golden%20hour%20lighting%2C%20quirky%20commercial%20district%2C%20cinematic%20composition&width=1200&height=500&seq=better-call-saul-poster&orientation=landscape',
    description: '《绝命毒师》前传，讲述小律师吉米·麦吉尔如何在生活的困境中一步步蜕变为专为罪犯服务的"风骚律师"索尔·古德曼。这是一个关于身份认同、道德模糊与生存挣扎的精彩故事。',
    director: '文斯·吉里根',
    cast: ['鲍勃·奥登科克', '蕾亚·塞洪', '乔纳森·班克斯', '吉安卡罗·埃斯波西托'],
    region: '美国',
    language: '英语',
    totalEpisodes: 63,
    currentEpisode: 63,
    status: '已完结',
    tags: ['犯罪', '剧情', '律政', '黑色幽默'],
    isFeatured: false,
    isHot: false,
    isNew: false,
    updateTime: '2024-02-01',
    episodes: Array.from({ length: 63 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '47分钟',
    })),
  },
  {
    id: 'drama-13',
    title: '重启人生',
    category: 'riju',
    subCategory: '奇幻喜剧',
    year: 2023,
    rating: 9.0,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20slice-of-life%20drama%20poster%20with%20ordinary%20woman%20in%20everyday%20setting%2C%20minimalist%20design%2C%20warm%20natural%20light%2C%20gentle%20color%20palette%2C%20J-drama%20aesthetic&width=600&height=800&seq=reboot-life-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20small%20town%20with%20traditional%20shops%20and%20cherry%20trees%2C%20warm%20afternoon%20sunlight%2C%20peaceful%20atmosphere%2C%20slice-of-life%20photography%2C%20gentle%20cinematic&width=1200&height=500&seq=reboot-life-poster&orientation=landscape',
    description: '33岁的近藤麻美是一名普通的公务员，在一次意外事故后去世。来到投胎中转站，她被告知下辈子将投胎成危地马拉的大食蚁兽。为了投胎成人，她决定重启人生，重新度过自己的一生，积攒足够的阴德。',
    director: '水野格',
    cast: ['安藤樱', '夏帆', '木南晴夏', '松坂桃李'],
    region: '日本',
    language: '日语',
    totalEpisodes: 10,
    currentEpisode: 10,
    status: '已完结',
    tags: ['奇幻', '喜剧', '人生', '温情'],
    isFeatured: false,
    isHot: true,
    isNew: false,
    updateTime: '2024-05-01',
    episodes: Array.from({ length: 10 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '45分钟',
    })),
  },
  {
    id: 'drama-14',
    title: '非自然死亡',
    category: 'riju',
    subCategory: '法医悬疑',
    year: 2018,
    rating: 9.3,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20medical%20mystery%20drama%20poster%20with%20female%20forensic%20doctor%20in%20white%20coat%2C%20laboratory%20background%2C%20serious%20expression%2C%20professional%20atmosphere%2C%20J-drama%20style&width=600&height=800&seq=unnatural-death-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Modern%20forensic%20laboratory%20interior%20with%20medical%20equipment%2C%20clean%20white%20aesthetic%2C%20professional%20atmosphere%2C%20Japanese%20drama%20visual%20style%2C%20bright%20clinical%20lighting&width=1200&height=500&seq=unnatural-death-poster&orientation=landscape',
    description: '三澄美琴是一名在非自然死亡原因研究所工作的法医。在日本，八成以上的非正常死亡未经解剖就被随意冠上一个死因。美琴和她个性鲜明的同事们一起，通过解剖还原真相，向不合理的死亡发起挑战。',
    director: '冢原亚由子',
    cast: ['石原里美', '井浦新', '洼田正孝', '市川实日子'],
    region: '日本',
    language: '日语',
    totalEpisodes: 10,
    currentEpisode: 10,
    status: '已完结',
    tags: ['法医', '悬疑', '推理', '职场'],
    isFeatured: false,
    isHot: false,
    isNew: false,
    updateTime: '2024-01-10',
    episodes: Array.from({ length: 10 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '54分钟',
    })),
  },
  {
    id: 'drama-15',
    title: '四重奏',
    category: 'riju',
    subCategory: '音乐剧情',
    year: 2017,
    rating: 9.1,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20poster%20with%20four%20musicians%20holding%20string%20instruments%20in%20cozy%20room%2C%20warm%20winter%20light%2C%20gentle%20atmosphere%2C%20artsy%20J-drama%20aesthetic%2C%20nostalgic%20tone&width=600&height=800&seq=quartet-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20living%20room%20with%20string%20instruments%2C%20winter%20light%20through%20window%2C%20warm%20interior%2C%20artsy%20atmosphere%2C%20music-themed%20decor%2C%20gentle%20cinematic&width=1200&height=500&seq=quartet-poster&orientation=landscape',
    description: '四个在KTV偶然相遇的男女组成了一个弦乐四重奏乐队。他们各自怀揣秘密，在轻井泽的别墅里共同生活，一起排练演奏。表面上是为了音乐梦想，实际上每个人都有着不为人知的过去和目的。',
    director: '土井裕泰',
    cast: ['松隆子', '满岛光', '高桥一生', '松田龙平'],
    region: '日本',
    language: '日语',
    totalEpisodes: 10,
    currentEpisode: 10,
    status: '已完结',
    tags: ['音乐', '剧情', '悬疑', '爱情'],
    isFeatured: false,
    isHot: false,
    isNew: false,
    updateTime: '2024-01-05',
    episodes: Array.from({ length: 10 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '46分钟',
    })),
  },
  {
    id: 'drama-16',
    title: '弥留之国的爱丽丝',
    category: 'riju',
    subCategory: '生存惊悚',
    year: 2020,
    rating: 8.0,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20survival%20thriller%20poster%20with%20young%20people%20in%20deserted%20Tokyo%20streets%2C%20playing%20cards%20motif%2C%20dystopian%20atmosphere%2C%20Netflix%20J-drama%20style%2C%20intense%20visual&width=600&height=800&seq=alice-borderland-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Deserted%20Tokyo%20Shibuya%20crossing%20completely%20empty%2C%20dystopian%20atmosphere%2C%20overgrown%20vegetation%2C%20eerie%20silence%2C%20post-apocalyptic%20cityscape%2C%20cinematic%20widescreen&width=1200&height=500&seq=alice-borderland-poster&orientation=landscape',
    description: '沉迷游戏的废柴青年有栖良平，一日与好友突然发现自己身处一个空无一人的东京。他们被迫参加一系列致命游戏来获取"签证"延长生存时间。每张扑克牌代表不同类型的游戏，输掉就意味着死亡。',
    director: '佐藤信介',
    cast: ['山崎贤人', '土屋太凤', '村上虹郎', '三吉彩花'],
    region: '日本',
    language: '日语',
    totalEpisodes: 16,
    currentEpisode: 16,
    status: '已完结',
    tags: ['生存', '惊悚', '科幻', '游戏'],
    isFeatured: false,
    isHot: false,
    isNew: false,
    updateTime: '2024-03-20',
    episodes: Array.from({ length: 16 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '50分钟',
    })),
  },
  {
    id: 'drama-17',
    title: '鬼灭之刃',
    category: 'dongman',
    subCategory: '热血战斗',
    year: 2019,
    rating: 9.2,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20young%20swordsman%20holding%20katana%2C%20water%20breathing%20effect%2C%20demon%20slayer%20uniform%2C%20dynamic%20action%20pose%2C%20vibrant%20colors%2C%20shonen%20anime%20style&width=600&height=800&seq=demon-slayer-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20mountain%20forest%20at%20night%20with%20moonlight%2C%20misty%20atmosphere%2C%20traditional%20Japanese%20aesthetic%2C%20fantasy%20landscape%2C%20epic%20composition&width=1200&height=500&seq=demon-slayer-poster&orientation=landscape',
    description: '大正时代，少年灶门炭治郎全家惨遭鬼的杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了找到让妹妹恢复成人的方法，炭治郎踏上了成为鬼杀队剑士的道路。一场关于家人、勇气与复仇的热血冒险就此展开。',
    director: '外崎春雄',
    cast: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    region: '日本',
    language: '日语',
    totalEpisodes: 63,
    currentEpisode: 63,
    status: '连载中',
    tags: ['热血', '战斗', '奇幻', '少年'],
    isFeatured: true,
    isHot: true,
    isNew: false,
    updateTime: '2026-07-30',
    episodes: Array.from({ length: 63 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '24分钟',
    })),
  },
  {
    id: 'drama-18',
    title: '葬送的芙莉莲',
    category: 'dongman',
    subCategory: '奇幻冒险',
    year: 2023,
    rating: 9.4,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20elf%20mage%20girl%20walking%20through%20flower%20field%2C%20nostalgic%20atmosphere%2C%20gentle%20color%20palette%2C%20fantasy%20adventure%2C%20emotional%20anime%20style&width=600&height=800&seq=frieren-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Fantasy%20landscape%20with%20rolling%20green%20hills%20and%20ancient%20ruins%2C%20blue%20sky%20with%20fluffy%20clouds%2C%20peaceful%20adventure%20atmosphere%2C%20anime%20background%20art%20style%2C%20serene%20composition&width=1200&height=500&seq=frieren-poster&orientation=landscape',
    description: '打倒魔王之后，勇者一行人中的精灵魔法使芙莉莲，因长寿种族的身世，面临着同伴逐渐老去的宿命。勇者辛美尔去世后，芙莉莲踏上了"了解人类"的旅程。这是一部关于时间、记忆与生命意义的温柔奇幻故事。',
    director: '斋藤圭一郎',
    cast: ['种崎敦美', '市之濑加那', '小林千晃', '冈本信彦'],
    region: '日本',
    language: '日语',
    totalEpisodes: 28,
    currentEpisode: 28,
    status: '已完结',
    tags: ['奇幻', '冒险', '治愈', '剧情'],
    isFeatured: true,
    isHot: true,
    isNew: false,
    updateTime: '2024-04-25',
    episodes: Array.from({ length: 28 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '24分钟',
    })),
  },
  {
    id: 'drama-19',
    title: '咒术回战',
    category: 'dongman',
    subCategory: '热血战斗',
    year: 2020,
    rating: 8.7,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20spiky%20haired%20boy%20surrounded%20by%20cursed%20energy%2C%20dynamic%20action%2C%20urban%20fantasy%2C%20dark%20supernatural%20theme%2C%20vibrant%20shonen%20style&width=600&height=800&seq=jujutsu-kaisen-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Tokyo%20cityscape%20with%20supernatural%20dark%20energy%20swirling%2C%20urban%20fantasy%20setting%2C%20dramatic%20sky%2C%20anime%20background%20art%2C%20intense%20atmosphere&width=1200&height=500&seq=jujutsu-kaisen-poster&orientation=landscape',
    description: '高中生虎杖悠仁偶然吞下诅咒之王两面宿傩的手指，成为了宿傩的容器。为了收集散落各地的宿傩手指，他加入东京都立咒术高等专门学校，与同伴们一起对抗诅咒，保护普通人的安全。',
    director: '朴性厚',
    cast: ['榎木淳弥', '内田雄马', '濑户麻沙美', '中村悠一'],
    region: '日本',
    language: '日语',
    totalEpisodes: 47,
    currentEpisode: 47,
    status: '连载中',
    tags: ['热血', '战斗', '超自然', '校园'],
    isFeatured: false,
    isHot: true,
    isNew: false,
    updateTime: '2026-07-22',
    episodes: Array.from({ length: 47 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '24分钟',
    })),
  },
  {
    id: 'drama-20',
    title: '间谍过家家',
    category: 'dongman',
    subCategory: '喜剧动作',
    year: 2022,
    rating: 8.9,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20family%20of%20three%20stylized%20characters%20in%20retro%20European%20setting%2C%20spy%20theme%2C%20warm%20comedy%2C%20pastel%20colors%2C%20heartwarming%20style&width=600&height=800&seq=spy-family-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=European-style%20city%20square%20with%20cobblestone%20streets%20and%20cafes%2C%20retro%201960s%20aesthetic%2C%20warm%20afternoon%20sunlight%2C%20charming%20atmosphere%2C%20anime%20background%20art&width=1200&height=500&seq=spy-family-poster&orientation=landscape',
    description: '为了执行维护东西和平的秘密任务，西国最强间谍"黄昏"不得不组建一个临时家庭。他收养的女儿是会读心的超能力者，妻子则是暗杀者。三人各怀秘密，却组成了一个奇妙而温暖的家庭。',
    director: '古桥一浩',
    cast: ['江口拓也', '种崎敦美', '早见沙织', '吉野裕行'],
    region: '日本',
    language: '日语',
    totalEpisodes: 37,
    currentEpisode: 37,
    status: '连载中',
    tags: ['喜剧', '动作', '家庭', '间谍'],
    isFeatured: false,
    isHot: false,
    isNew: false,
    updateTime: '2026-07-15',
    episodes: Array.from({ length: 37 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: '24分钟',
    })),
  },
  {
    id: 'drama-21',
    title: '奔跑吧第八季',
    category: 'zongyi',
    subCategory: '户外竞技',
    year: 2024,
    rating: 7.5,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20and%20laughing%2C%20colorful%20dynamic%20design%2C%20energetic%20atmosphere%2C%20outdoor%20adventure%20theme%2C%20entertainment%20style&width=600&height=800&seq=running-man-cn-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Bright%20outdoor%20amusement%20park%20with%20colorful%20obstacles%20and%20challenges%2C%20sunny%20day%2C%20energetic%20atmosphere%2C%20variety%20show%20set%2C%20fun%20and%20exciting&width=1200&height=500&seq=running-man-cn-poster&orientation=landscape',
    description: '国民综艺《奔跑吧》第八季强势回归！常驻嘉宾阵容全面升级，更有神秘飞行嘉宾空降。经典撕名牌大战再度升级，全新的游戏环节和挑战任务，带你感受最燃最炸的户外竞技体验。',
    director: '姚译添',
    cast: ['李晨', '郑恺', '沙溢', '白鹿'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 12,
    currentEpisode: 8,
    status: '连载中',
    tags: ['户外', '竞技', '搞笑', '真人秀'],
    isFeatured: false,
    isHot: true,
    isNew: true,
    updateTime: '2026-08-02',
    episodes: Array.from({ length: 12 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}期`,
      duration: '90分钟',
    })),
  },
  {
    id: 'drama-22',
    title: '向往的生活第七季',
    category: 'zongyi',
    subCategory: '慢生活',
    year: 2024,
    rating: 8.1,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20slow-life%20variety%20show%20poster%20with%20rural%20farmhouse%20and%20green%20fields%2C%20warm%20rustic%20atmosphere%2C%20peaceful%20countryside%2C%20healing%20entertainment%20style&width=600&height=800&seq=back-to-field-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20countryside%20with%20traditional%20farmhouse%2C%20rice%20paddies%2C%20misty%20mountains%20in%20background%2C%20golden%20hour%20light%2C%20peaceful%20rural%20landscape&width=1200&height=500&seq=back-to-field-poster&orientation=landscape',
    description: '黄磊与何炅带着新老朋友回归田园，在美丽的乡村小屋中，自给自足，招待远道而来的客人。劈柴、种菜、做饭、聊天——在这里，时间慢下来，生活回归最简单的美好。',
    director: '王征宇',
    cast: ['黄磊', '何炅', '张艺兴', '彭昱畅'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 14,
    currentEpisode: 14,
    status: '已完结',
    tags: ['慢生活', '美食', '田园', '治愈'],
    isFeatured: false,
    isHot: false,
    isNew: false,
    updateTime: '2024-05-30',
    episodes: Array.from({ length: 14 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}期`,
      duration: '100分钟',
    })),
  },
  {
    id: 'drama-23',
    title: '歌手2024',
    category: 'zongyi',
    subCategory: '音乐竞技',
    year: 2024,
    rating: 8.4,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%20with%20spotlight%20stage%20and%20microphone%2C%20dramatic%20lighting%2C%20premium%20variety%20show%20design%2C%20elegant%20gold%20and%20black%20theme&width=600&height=800&seq=singer2024-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dramatic%20spotlights%20and%20fog%20effects%2C%20empty%20arena%20seats%2C%20premium%20production%20design%2C%20elegant%20dark%20atmosphere%2C%20professional%20music%20show&width=1200&height=500&seq=singer2024-poster&orientation=landscape',
    description: '华语乐坛顶级音乐竞技节目《歌手2024》震撼回归。本季采用全程直播形式，国内外顶级歌手同台竞演。没有修音，没有后期，只有最真实的live实力较量。谁将问鼎歌王宝座？',
    director: '洪涛',
    cast: ['那英', '汪苏泷', '杨丞琳', '海来阿木'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 12,
    currentEpisode: 12,
    status: '已完结',
    tags: ['音乐', '竞技', '直播', '歌手'],
    isFeatured: false,
    isHot: false,
    isNew: false,
    updateTime: '2024-06-20',
    episodes: Array.from({ length: 12 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}期`,
      duration: '120分钟',
    })),
  },
  {
    id: 'drama-24',
    title: '名侦探学院第七季',
    category: 'zongyi',
    subCategory: '推理竞技',
    year: 2024,
    rating: 9.0,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20detective%20variety%20show%20poster%20with%20young%20smart%20contestants%20in%20school%20uniforms%2C%20mystery%20theme%2C%20dark%20academic%20aesthetic%2C%20puzzle%20elements&width=600&height=800&seq=detective-academy-cover&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Mysterious%20library%20with%20wooden%20bookshelves%20and%20chess%20pieces%2C%20detective%20theme%2C%20warm%20lamplight%2C%20intellectual%20atmosphere%2C%20dark%20academia%20aesthetic&width=1200&height=500&seq=detective-academy-poster&orientation=landscape',
    description: '高颜值高智商学长团再度集结！蒲熠星、文韬、齐思钧等学霸们在全新升级的推理游戏中斗智斗勇，从剧本杀到密室逃脱，从狼人杀到逻辑推理，展现出令人叹为观止的脑力对决。',
    director: '何舒',
    cast: ['蒲熠星', '文韬', '齐思钧', '石凯'],
    region: '中国大陆',
    language: '汉语普通话',
    totalEpisodes: 12,
    currentEpisode: 6,
    status: '连载中',
    tags: ['推理', '竞技', '脑力', '学院'],
    isFeatured: false,
    isHot: false,
    isNew: true,
    updateTime: '2026-07-31',
    episodes: Array.from({ length: 12 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}期`,
      duration: '90分钟',
    })),
  },
];

export const categoryMap: Record<string, string> = {
  guochan: '国产剧',
  hanju: '韩剧',
  meiju: '美剧',
  riju: '日剧',
  dongman: '动漫',
  zongyi: '综艺',
};